/*
 Created by CHT 2019/12/4 10:49
 统计表（图表控件）
*/
import BaseChart from "../BaseChart"
import {
  CHART_CATEGORY__CHART, CHART_TYPE__FILTER_CONTROL,
  CHART_TYPE__STATISTICS, SHORTCUT_BUTTON_TYPE__APPLY_FORM,
  SHOW_TYPE__AREA,
  SHOW_TYPE__CLUSTER_BAR, SHOW_TYPE__FUNNEL,
  SHOW_TYPE__INDICATOR,
  SHOW_TYPE__LINE, SHOW_TYPE__MAP,
  SHOW_TYPE__MEASURE,
  SHOW_TYPE__PERCENT_BAR,
  SHOW_TYPE__PERCENT_STRIP,
  SHOW_TYPE__PIE, SHOW_TYPE__PIVOT_TABLE,
  SHOW_TYPE__RADAR, SHOW_TYPE__SCATTER,
  SHOW_TYPE__STACKED_BAR,
  SHOW_TYPE__STACKED_STRIP,
  SHOW_TYPE__STRIP, SHOW_TYPE__SUNBURST, SHOW_TYPE__TREE_MAP, SOURCE_TYPE__FLOW_FORM, STATISTICS_STRATEGY__SUM
} from "../types"
import {
  FORM_ITEM__SINGLE_LINE,
  FORM_ITEM__MULTILINE
} from "../../RyForm/types"
import {DASHBOARD_DATA_SOURCE_EXIST, SUCCESS} from "../../../src/store/types";
import {uuid} from "../utils";
import {filterEmpty, gradient, isNull, isNumber} from "../../../assets/js/Untis";

class Statistics extends BaseChart {
  constructor() {
    super()

    this.showType = ''

    this.minH = 5
    this.minW = 10

    this.chartPropertiesHolder = {
      latitudeFields: [ // 行纬度（视角）字段
        /*
        {
          "dataId":"",      // 字段id
          "type":"",        // 控件类型
          "oriName":"",     // 原名称
          "showName":"",    // 展示名称
          "sortBy":1,       // 排序方式，0:默认，1:正序，-1：倒序，2:自定义排序
          "sortList":[      // 自定义排序时的字段值，（BDP最多100条）
            ""
          ],
          "groupBy":""      // 汇总方式，用于日期类控件和位置类控件，具体方式见上方表格
        }
        */
      ],
      colLatitudeFields: [ // 列纬度（视角）字段
        /*
        {
          "dataId":"",      // 字段id
          "type":"",        // 控件类型
          "oriName":"",     // 原名称
          "showName":"",    // 展示名称
          "sortBy":1,       // 排序方式，0:默认，1:正序，-1：倒序，2:自定义排序
          "sortList":[      // 自定义排序时的字段值，（BDP最多100条）
            ""
          ],
          "groupBy":""      // 汇总方式，用于日期类控件和位置类控件，具体方式见上方表格
        }
        */
      ],
      showFields: [ // 数值1
        /*
        {
          "dataId":"",              // 字段id
          "type":"",                // 控件类型
          "oriName": "",            // 原名称
          "showName":"",            // 展示名称
          "sortBy":1,               // 排序方式，0:默认，1:正序，-1：倒序
          "statisticsStrategy":"",  // 汇总方式，见上方表格定义
          "dataFormatter":"",       // 数据格式，见上方图片
          "showFormatter":""        // 计算方式，见上方定义
        }
        */
      ],      // 指标
      showContrast: 0,    // 显示对比轴
      contrast: [          // 对比轴
        /*
        {
          "dataId":"",    // 字段id
          "type":"",        // 控件类型
          "oriName":"",   // 原名称
          "showName":"",  // 展示名称
          "sortBy":1,     // 排序方式，0:默认，1:正序，-1：倒序，2:自定义排序
          "sortList":[    // 自定义排序时的字段值，（BDP最多100条）
            ""
          ],
          "groupBy":""   // 汇总方式，用于日期类控件和位置类控件，具体方式见上方表格
        }
       */
      ],
      showSecond: 0,      // 显示次轴
      secondShowField: [ // 数值2
        /*
         {
          "dataId":"",              // 字段id
          "type":"",                // 控件类型
          "oriName": "",            // 原名称
          "showName":"",            //  展示名称
          "sortBy":1,               // 排序方式，0:默认，1:正序，-1：倒序
          "statisticsStrategy":"",  //汇总方式，见上方表格定义
          "dataFormatter":"",       //  数据格式，见上方图片
          "showFormatter":""        //  计算方式，见上方定义
         }
         */
      ],
      filter: {
        relation: "and",
        notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
        conditionList: [
          /*
            {
              "type":"singleline",
              "method":"eq",
              "value":["No.00001"],
              "fieldId":"SINGLELINEk31hfr93CgKUtL6J"
            }
          */
        ]
      },
      warnSetting: [],   // 预警设置
      aideLine: [
        /*
          {
            "lineName":"",  //辅助线名称
            "valueType":"", //值类型，固定值：fixed,动态值：dynamic
            "fixedValue":12,  //固定值，固定值类型时必传
            "dynamicValue":{  //动态值，动态值类型时必传
              "dataId":"",  //控件id，必须是指标或者次轴中展示的控件
              "statisticsStrategy":"" //见上方定义
            },
            "showType":"",  //展示类型，仅名称：k 仅值：v 名称和值：kv
            "color":""  //颜色
          }
         */
      ],       // 辅助线设置
      maxEnable: 0,         // 显示前n条数据开关
      maxCount: "",          // 条数
      propertiesSetting: { //属性设置 (计量图使用)
        title: "", // 标题
        unit: "",  // 单位
        prec: 0, // 完成率小数点
        valueType: "FIXED", // 值类型，固定值 ： FIXED,计算值：FUNC
        valueDataId: "", // 当值类型为计算值时必传，计算字段的id
        valueStatisticsStrategy: STATISTICS_STRATEGY__SUM, // 计算函数，当值类型为计算值时必传，见上方定义
        value: 0,  // 固定值，固定值类型时必传，数字
        valueSeparator: 1, // 值使用千位分隔符
        valuePrec: 0,  // 值小数位数
        valueUnit: "",  // 值单位，["自动","无","万","亿","K","M","G"]
        appId: "", //目标appId
        dataSourceType: SOURCE_TYPE__FLOW_FORM,  //见上方定义
        dataSourceId: "",  //目标表单id
        filter: {
          relation: "and",  //and or
          notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
          conditionList: [
            // {
            //   "key":"", //key
            //   "fixedValue":"",  //current_user 当前用户 now 当前时间 fixed_value 固定的值
            //   "type":"",  //同筛选对象
            //   "method":"",  //同筛选对象
            //   "value":[], //同筛选对象
            //   "fieldId":"", //筛选字段
            //   "localFieldId":"" //localFieldId
            // }
          ]
        },
      },


      funcFields: [  //函数字段
        // {
        // "dataId":"",  //随机生成，与其余字段不重复
        // "fieldTitle":"",  //名称
        // "formulaExpr": "$fieldId$-$fieldId$", //公式表达式
        // "paramList": [  //公式参数列表
        //   {
        //     "formId": "5e2831fe000d1c0a3b0012f8",
        //     "envVarName": "DESCRIPTION_k6swyegxO66sxlbO"
        //   }
        // ]
        // }
      ],
    }

    this.showPropertiesHolder = {}

    this.showTypeOptional = [
      {
        label: '指标图(指标卡)',
        use: true,
        available: false,
        des: [
          '0个维度，1个或多个指标',
        ],
        icon: 'iconfont icon-zhibiaoqia',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = (latitude === 0 && quota >= 1) && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__INDICATOR,
          showPropertiesHolder: {
            jumpUrl: '',  // 跳转链接
            legendDes: [],
            title: '',
            showTitle: 0, // 是否显示图表组件标题
            optionType: '',  //applyForm:发起表单, openView:打开视图, openUrl:打开链接,
            //根据类型解析
            optionContent: {
              //发起表单
              appId: "",
              formId: "",

              //打开视图
              //   "appId":"",
              //   "formId":"",
              jumpType: 1, // 1跳转视图，2跳转仪表盘
              viewId: "",

              //打开链接
              url: "",

              // 绑定微信
              bindType: 0, // 0公众号 1小程序
              // 邀请成员
              inviteType: 0, // 0成员 1外部联系人

            },
            newPage: 1,  //是否在新页面打开，否则弹窗展示
            color: this.colorOpts[0], //颜色
            customColor: "", // 自定义颜色
            icon: "" //图标
          }
        }
      },
      {
        label: '透视表',
        use: true,
        available: false,
        des: [
          '1个维度，1个或多个指标',
          '多个维度，1个或多个指标'
        ],
        icon: 'iconfont icon-biaoge',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = (latitude > 0 || colLatitude > 0) && quota > 0
        },
        value: {
          showType: SHOW_TYPE__PIVOT_TABLE,
          showPropertiesHolder: {
            // 图表验证配置
            fixedCol: 1, // 冻结列
            fixedRow: 1, // 冻结行
            conditionalFormatting: []
          }
        }
      },
      {
        label: '计量图',
        use: true,
        available: false,
        des: [
          '0个维度，1个指标'
        ],
        icon: 'iconfont icon-jiliangtu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = latitude === 0 && quota === 1
        },
        value: {
          showType: SHOW_TYPE__MEASURE,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#9BCC66',
                '#3FB27E',
                '#F35352',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#F8CB7F',
                '#EDDD86',
                '#9987CE'
              ]
            },
            colors: [
              {
                type: 'range',
                values: [0, 25],
                value: 0,
                color: '#63B2EE'
              },
              {
                type: 'range',
                values: [25, 50],
                value: 0,
                color: '#3FB27E'
              },
              {
                type: 'range',
                values: [50, 75],
                value: 0,
                color: '#F89588'
              },
              {
                type: 'range',
                values: [75, 100],
                value: 0,
                color: '#F35352'
              },
            ],
            title: '',
            subTitle: ''
          }
        }
      },
      {
        label: '簇状柱形图',
        use: false,
        available: false,
        des: [
          '1个维度，1个或多个指标',
          '2个维度,1个指标'
        ],
        icon: 'iconfont icon-cuzhuangzhuxingtu-jihuo',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = ((latitude === 1 && quota >= 1) || (latitude === 2 && quota === 1)) && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__CLUSTER_BAR,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            colors: [
              // {name:'', color:''}
            ],
            xAxisDirection: 'hor',  // ver 竖向。 hor 水平。 left 左倾斜。 right 右倾斜
            yAxisTitle: '', // y轴标题
            yAxisMax: '', // y轴最大值
            yAxisMin: '', // y轴最小值
            showDataTag: 1, // 显示数据标签
            showLegend: 1, // 显示图例
            legend: {
              name: '底部',
              value: {
                type: 'scroll',
                orient: 'horizontal', // horizontal 水平。 vertical 垂直
                // top: 20,
                // right: 20,
                bottom: 20, // 默认，水平显示在底部
                // left: 20,
              }
            } // 显示图例配置
          }
        }
      },
      {
        label: '条形图',
        use: false,
        available: false,
        des: [
          '1个或2个维度，1个或多个指标'
        ],
        icon: 'iconfont icon-icon-tiaoxingtu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = (latitude === 1 || latitude === 2) && (quota >= 1) && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__STRIP,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            colors: [
              // {name:'', color:''}
            ],
            xAxisDirection: 'hor',  // ver 竖向。 hor 水平。 left 左倾斜。 right 右倾斜
            yAxisTitle: '', // y轴标题
            yAxisMax: '', // y轴最大值
            yAxisMin: '', // y轴最小值
            showDataTag: 1, // 显示数据标签
            showLegend: 1, // 显示图例
            legend: {
              name: '底部',
              value: {
                type: 'scroll',
                orient: 'horizontal', // horizontal 水平。 vertical 垂直
                // top: 20,
                // right: 20,
                bottom: 20, // 默认，水平显示在底部
                // left: 20,
              }
            } // 显示图例配置
          }
        }
      },
      {
        label: '雷达图',
        use: false,
        available: false,
        des: [
          '1个维度，1个或多个指标'
        ],
        icon: 'iconfont icon-leidatu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = latitude === 1 && quota >= 1 && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__RADAR,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            showDataTag: 1, // 显示数据标签
            showLegend: 1, // 显示图例
            legend: {
              name: '底部',
              value: {
                type: 'scroll',
                orient: 'horizontal', // horizontal 水平。 vertical 垂直
                // top: 20,
                // right: 20,
                bottom: 20, // 默认，水平显示在底部
                // left: 20,
              }
            } // 显示图例配置
          }
        }
      },
      {
        label: '折线图',
        use: false,
        available: false,
        des: [
          '1个或2个维度、1个或多个指标'
        ],
        icon: 'iconfont icon-tubiaozhexiantu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = (latitude === 1 || latitude === 2) && quota >= 1 && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__LINE,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            xAxisDirection: 'hor',  // ver 竖向。 hor 水平。 left 左倾斜。 right 右倾斜
            yAxisTitle: '', // y轴标题
            yAxisMax: '', // y轴最大值
            yAxisMin: '', // y轴最小值
            showDataTag: 1, // 显示数据标签
            showLegend: 1, // 显示图例
            legend: {
              name: '底部',
              value: {
                type: 'scroll',
                orient: 'horizontal', // horizontal 水平。 vertical 垂直
                // top: 20,
                // right: 20,
                bottom: 20, // 默认，水平显示在底部
                // left: 20,
              }
            } // 显示图例配置
          },
        }
      },
      {
        label: '面积图',
        use: false,
        available: false,
        des: [
          '1个维度、1个或多个指标'
        ],
        icon: 'iconfont icon-mianjitu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = latitude === 1 && quota >= 1 && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__AREA,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            xAxisDirection: 'hor',  // ver 竖向。 hor 水平。 left 左倾斜。 right 右倾斜
            yAxisTitle: '', // y轴标题
            yAxisMax: '', // y轴最大值
            yAxisMin: '', // y轴最小值
            showDataTag: 1, // 显示数据标签
            showLegend: 1, // 显示图例
            legend: {
              name: '底部',
              value: {
                type: 'scroll',
                orient: 'horizontal', // horizontal 水平。 vertical 垂直
                // top: 20,
                // right: 20,
                bottom: 20, // 默认，水平显示在底部
                // left: 20,
              }
            } // 显示图例配置
          }
        }
      },
      {
        label: '饼图',
        use: false,
        available: false,
        des: [
          '1个维度，1个指标',
          '0个维度，多个指标'
        ],
        icon: 'iconfont icon-bingtu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = ((latitude === 1 && quota === 1) || (latitude === 0 && quota >= 1)) && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__PIE,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            colors: [
              // {name:'', color:''}
            ],
            pieStyle: 1, // 1 饼形。 2 环形。 3南丁格尔玫瑰图
            showDataTag: 1, // 显示数据标签
            showDimensionTag: 1, // 显示维度值
            showIndexTag: 1, // 显示指标值
            showPercentageTag: 1, // 显示百分比
            showLegend: 1, // 显示图例
            legend: {
              name: '底部',
              value: {
                type: 'scroll',
                orient: 'horizontal', // horizontal 水平。 vertical 垂直
                // top: 20,
                // right: 20,
                bottom: 20, // 默认，水平显示在底部
                // left: 20,
              }
            } // 显示图例配置
          }
        }
      },
      {
        label: '漏斗图',
        use: false,
        available: false,
        des: [
          '1个维度，1个指标',
          '0个维度，多个指标'
        ],
        icon: 'iconfont icon-loudoutu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = ((latitude === 1 && quota === 1) || (latitude === 0 && quota >= 1)) && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__FUNNEL,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            showDataTag: 1, // 显示数据标签
            showLegend: 1, // 显示图例
            legend: {
              name: '底部',
              value: {
                type: 'scroll',
                orient: 'horizontal', // horizontal 水平。 vertical 垂直
                // top: 20,
                // right: 20,
                bottom: 20, // 默认，水平显示在底部
                // left: 20,
              }
            } // 显示图例配置
          }
        }
      },
      {
        label: '散点图',
        use: false,
        available: false,
        des: [
          '0个或多个维度',
          '2个指标'
        ],
        icon: 'iconfont icon-sandian',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = (latitude >= 0 && quota === 2) && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__SCATTER,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            xAxisDirection: 'hor',  // ver 竖向。 hor 水平。 left 左倾斜。 right 右倾斜
            yAxisTitle: '', // y轴标题
            yAxisMax: '', // y轴最大值
            yAxisMin: '', // y轴最小值
            xAxisTitle: '', // x轴标题
            showDataTag: 1, // 显示数据标签
          }
        }
      },
      {
        label: '旭日图',
        use: false,
        available: false,
        des: [
          '2个或多个维度 1个指标',
        ],
        icon: 'iconfont icon-xuritu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = (latitude >= 2 && quota === 1) && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__SUNBURST,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            colors: [
              // {name:'', color:''}
            ],
            showDataTag: 1, // 显示数据标签
          }
        }
      },
      {
        label: '矩形树图',
        use: false,
        available: false,
        des: [
          '1个或多个维度',
          '0个或1个指标'
        ],
        icon: 'iconfont icon-juxingshutu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = latitude >= 1 && (quota === 0 || quota === 1) && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__TREE_MAP,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            theme: {
              index: 0,
              name: '经典配色',
              value: [
                '#63B2EE',
                '#76DA91',
                '#F8CB7F',
                '#F89588',
                '#7CD6CF',
                '#9192AB',
                '#7898E1',
                '#EFA666',
                '#EDDD86',
                '#9987CE'
              ]
            },
            //
            showFieldsColor: {
              // dataId: '#00000'
            },
            colors: [
              // {name:'', color:''}
            ],
            showDataTag: 1, // 显示数据标签
            showLegend: 1, // 显示图例
            legend: {
              name: '底部',
              value: {
                type: 'scroll',
                orient: 'horizontal', // horizontal 水平。 vertical 垂直
                // top: 20,
                // right: 20,
                bottom: 20, // 默认，水平显示在底部
                // left: 20,
              }
            } // 显示图例配置
          }
        }
      },
      {
        label: '地图',
        use: false,
        available: false,
        des: [
          '1个地理维度 1个指标'
        ],
        icon: 'iconfont icon-zhongguoditu',
        usable({latitude, quota, colLatitude, latitudeFields, colLatitudeFields}) {
          this.available = latitude === 1 && latitudeFields[0].type === 'address' && quota === 1 && colLatitude === 0
        },
        value: {
          showType: SHOW_TYPE__MAP,
          showPropertiesHolder: {
            // 图表验证配置
            showTitle: 1,
            legendDes: [],
            showFieldsColor: {
              // dataId: '#00000'
            },
            color: {
              name: '天空',
              value: [
                '#B5E9F5',
                '#0361E5'
              ]
            },
            title: '',
            subTitle: '',
            showDataTag: 1, // 显示数据标签
            showDimensionTag: 1, // 显示维度值
            showIndexTag: 0, // 显示指标值
          }
        }
      }
    ]

    this.value = null

    this.tempFilter = null
  }

  get title() {
    return this.chartName || Statistics._title
  }

  set title(content) {
    this.chartName = content
  }

}

Statistics._title = '统计图表'
Statistics.type = CHART_TYPE__STATISTICS

// 各个图表提示框统一样式
Statistics.prototype.toolTipsOpts = {
  textStyle: {
    color: '#333',
    fontSize: '12'
  },
  padding: 10,
  backgroundColor: '#fff' // 悬浮框背景色设置
}
Statistics.prototype.chartCategory = CHART_CATEGORY__CHART
Statistics.prototype.chartType = Statistics.type

Statistics.prototype.presetMap = {
  'preset_map_1': {
    startColor: '#B5E9F5',
    endColor: '#0361E5',
    color: 'linear-gradient(to right, rgb(181, 233, 245) 0%, rgb(3, 97, 229) 100%)'
  },
  'preset_map_2': {
    startColor: '#FFF9E3',
    endColor: '#B58D02',
    color: 'linear-gradient(to right, rgb(255, 249, 227) 0%, rgb(181, 141, 2) 100%)'
  },
  'preset_map_3': {
    startColor: '#F4E9FE',
    endColor: '#7531AC',
    color: 'linear-gradient(to right, rgb(244, 233, 254) 0%, rgb(117, 49, 172) 100%)'
  },
  'preset_map_4': {
    startColor: '#E3F5DA',
    endColor: '#174700',
    color: 'linear-gradient(to right, rgb(227, 245, 218) 0%, rgb(23, 71, 0) 100%)'
  },
  'preset_map_5': {
    startColor: '#E4F7FF',
    endColor: '#0B5F83',
    color: 'linear-gradient(to right, rgb(228, 247, 255) 0%, rgb(11, 95, 131) 100%)'
  },
  'preset_map_6': {
    startColor: '#A4EBB3',
    endColor: '#04BAF3',
    color: 'linear-gradient(to right, rgb(164, 235, 179) 0%, rgb(4, 186, 243) 100%)'
  },
  'preset_map_7': {
    startColor: '#DFECC1',
    endColor: '#E9272B',
    color: 'linear-gradient(to right, rgb(223, 236, 193) 0%, rgb(233, 39, 43) 100%)'
  }
}

Statistics.prototype.showTypeSwitch = function (opts) {
  const {
    latitude = 0,   // 维度
    quota = 0,       // 指标
    colLatitude = 0, // 列纬度
    latitudeFields = [], // 维度集合
    colLatitudeFields = [] // 列纬度集合
  } = opts
  this.showTypeOptional.forEach(item => {
    if (item.usable) item.usable({
      latitude,
      quota,
      colLatitude,
      latitudeFields,
      colLatitudeFields
    })
  })
}
// 重置数据源
Statistics.prototype.resetDataSource = function (opts) {
  const {
    dataSourceName,
    dataSourceType,
    dataSourceId
  } = opts

  this.dataSourceName = dataSourceName
  this.dataSourceId = dataSourceId
  this.dataSourceType = dataSourceType

  this.chartPropertiesHolder = {
    latitudeFields: [ // 纬度（视角）字段
      /*
      {
        "dataId":"",      // 字段id
        "type":"",        // 控件类型
        "oriName":"",     // 原名称
        "showName":"",    // 展示名称
        "sortBy":1,       // 排序方式，0:默认，1:正序，-1：倒序，2:自定义排序
        "sortList":[      // 自定义排序时的字段值，（BDP最多100条）
          ""
        ],
        "groupBy":""      // 汇总方式，用于日期类控件和位置类控件，具体方式见上方表格
      }
      */
    ],
    colLatitudeFields: [ // 列纬度（视角）字段
      /*
      {
        "dataId":"",      // 字段id
        "type":"",        // 控件类型
        "oriName":"",     // 原名称
        "showName":"",    // 展示名称
        "sortBy":1,       // 排序方式，0:默认，1:正序，-1：倒序，2:自定义排序
        "sortList":[      // 自定义排序时的字段值，（BDP最多100条）
          ""
        ],
        "groupBy":""      // 汇总方式，用于日期类控件和位置类控件，具体方式见上方表格
      }
      */
    ],
    showFields: [ // 数值1
      /*
      {
        "dataId":"",              // 字段id
        "type":"",                // 控件类型
        "oriName": "",            // 原名称
        "showName":"",            // 展示名称
        "sortBy":1,               // 排序方式，0:默认，1:正序，-1：倒序
        "statisticsStrategy":"",  // 汇总方式，见上方表格定义
        "dataFormatter":"",       // 数据格式，见上方图片
        "showFormatter":""        // 计算方式，见上方定义
      }
      */
    ],      // 指标
    showContrast: 0,    // 显示对比轴
    contrast: [          // 对比轴
      /*
      {
        "dataId":"",    // 字段id
        "type":"",        // 控件类型
        "oriName":"",   // 原名称
        "showName":"",  // 展示名称
        "sortBy":1,     // 排序方式，0:默认，1:正序，-1：倒序，2:自定义排序
        "sortList":[    // 自定义排序时的字段值，（BDP最多100条）
          ""
        ],
        "groupBy":""   // 汇总方式，用于日期类控件和位置类控件，具体方式见上方表格
      }
     */
    ],
    showSecond: 0,      // 显示次轴
    secondShowField: [ // 数值2
      /*
       {
        "dataId":"",              // 字段id
        "type":"",                // 控件类型
        "oriName": "",            // 原名称
        "showName":"",            //  展示名称
        "sortBy":1,               // 排序方式，0:默认，1:正序，-1：倒序
        "statisticsStrategy":"",  //汇总方式，见上方表格定义
        "dataFormatter":"",       //  数据格式，见上方图片
        "showFormatter":""        //  计算方式，见上方定义
       }
       */
    ],
    filter: {
      relation: "and",
      notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: [
        /*
          {
            "type":"singleline",
            "method":"eq",
            "value":["No.00001"],
            "fieldId":"SINGLELINEk31hfr93CgKUtL6J"
          }
        */
      ]
    },
    warnSetting: [],   // 预警设置
    aideLine: [
      /*
        {
          "lineName":"",  //辅助线名称
          "valueType":"", //值类型，固定值：fixed,动态值：dynamic
          "fixedValue":12,  //固定值，固定值类型时必传
          "dynamicValue":{  //动态值，动态值类型时必传
            "dataId":"",  //控件id，必须是指标或者次轴中展示的控件
            "statisticsStrategy":"" //见上方定义
          },
          "showType":"",  //展示类型，仅名称：k 仅值：v 名称和值：kv
          "color":""  //颜色
        }
       */
    ],       // 辅助线设置
    maxEnable: 0,         // 显示前n条数据开关
    maxCount: "",          // 条数
    propertiesSetting: { //属性设置 (计量图使用)
      title: "", // 标题
      unit: "",  // 单位
      prec: 0, // 完成率小数点
      valueType: "FIXED", // 值类型，固定值 ： FIXED,计算值：FUNC
      valueDataId: "", // 当值类型为计算值时必传，计算字段的id
      valueStatisticsStrategy: STATISTICS_STRATEGY__SUM, // 计算函数，当值类型为计算值时必传，见上方定义
      value: 0,  // 固定值，固定值类型时必传，数字
      valueSeparator: 1, // 值使用千位分隔符
      valuePrec: 0,  // 值小数位数
      valueUnit: "",  // 值单位，["自动","无","万","亿","K","M","G"]
      appId: "", //目标appId
      dataSourceType: SOURCE_TYPE__FLOW_FORM,  //见上方定义
      dataSourceId: "",  //目标表单id
      filter: {
        relation: "and",  //and or
        notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
        conditionList: [
          // {
          //   "key":"", //key
          //   "fixedValue":"",  //current_user 当前用户 now 当前时间 fixed_value 固定的值
          //   "type":"",  //同筛选对象
          //   "method":"",  //同筛选对象
          //   "value":[], //同筛选对象
          //   "fieldId":"", //筛选字段
          //   "localFieldId":"" //localFieldId
          // }
        ]
      },
    },


    funcFields: [  //函数字段
      // {
      // "dataId":"",  //随机生成，与其余字段不重复
      // "fieldTitle":"",  //名称
      // "formulaExpr": "$fieldId$-$fieldId$", //公式表达式
      // "paramList": [  //公式参数列表
      //   {
      //     "formId": "5e2831fe000d1c0a3b0012f8",
      //     "envVarName": "DESCRIPTION_k6swyegxO66sxlbO"
      //   }
      // ]
      // }
    ],

  }

  // 清除相关筛选器数据
  this.parent.children.forEach(chart => {
    if (chart.chartType === CHART_TYPE__FILTER_CONTROL) {
      if (Object.keys(chart.chartPropertiesHolder.chartFilterMap).includes(this.chartId)) {
        delete chart.chartPropertiesHolder.chartFilterMap[this.chartId]
      }
    }
  })
}
Statistics.prototype.getValue = function (opts = {}, filter, isSetting = false) {

  if (this.hidden) {
    // 图表不可见，不用请求数据
    return
  }

  this.isLoad = false

  const chart = Object.assign(this.getBase(), opts)

  if (!filter) {
    const chartCondition = []
    this.parent.children
      .filter(chart => chart.chartType === CHART_TYPE__FILTER_CONTROL)
      .forEach(filterControl => {
        const holder = filterControl.chartPropertiesHolder
        const filterConf = holder.chartFilterMap[this.chartId]

        if (filterConf && filterControl.value.method) {
          chartCondition.push({
            type: "",
            method: filterControl.value.method,
            value: filterControl.value.value,
            fieldId: filterConf.dataId,
            fixedValue: filterControl.value.fixedValue,
            extValue: filterControl.value.extValue
          })
        }
      })

    filter = {
      relation: "and",
      notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: chartCondition,
    }
  }

  if (((this.parent.styles && this.parent.styles.filterEmptyLoadData && this.parent.styles.filterEmptyLoadData === 'NO') ||
    (this.showPropertiesHolder.filterEmptyLoadData && this.showPropertiesHolder.filterEmptyLoadData === 'NO')) && filterEmpty(filter)) {

    this.value = null
    this.isLoad = true
    return new Promise(function (resolve, reject) {
      resolve(null)
    })
  }
  // 这里存一个临时的filter，数据下钻需要使用
  this.tempFilter = filter
  return this.parent.chartDataPreviewFun({
    chartId: this.chartId,
    currentPage: -1,
    pageSize: -1,
    sort: {},
    filter,
    chart
  }).then(({status, resultObject, info}) => {

    if (status === SUCCESS) {
      if (this.showType === SHOW_TYPE__PIVOT_TABLE) {
        this.formatData(resultObject, chart)
        this.transformData(resultObject, chart)
        this.calculateColor(resultObject, chart)
      }
      if (isSetting) {
        return resultObject
      } else {
        this.value = resultObject
      }
    } else if (status === DASHBOARD_DATA_SOURCE_EXIST) {
      this.errorPrompt = '控件已删除'
    }
  }).catch(err => {
    console.error(err)
  }).finally(() => {
    this.isLoad = true
  })
}
Statistics.prototype.resetValue = function () {
}

Statistics.prototype.formatData = function (value, opts) {
  value = value || this.value
  const showFields = opts.chartPropertiesHolder.showFields.map(item => item.idx)

  value.body.forEach((arr, idx) => {

    arr.forEach(v => {
      if (showFields.includes(v.linkId) && v.content !== '-') {
        // v.content = Math.round(parseFloat(v.content) * Math.pow(10, 2)) / Math.pow(10, 2)
        v.content = parseFloat(v.content)
      } else if (!v.linkId && v.content !== '汇总' && isNumber(parseFloat(v.content))) {
        // v.content = Math.round(parseFloat(v.content) * Math.pow(10, 2)) / Math.pow(10, 2)
        v.content = parseFloat(v.content)
      }
    })
  })
}

Statistics.prototype.transformData = function (value, opts) {

  opts.chartPropertiesHolder.colLatitudeFields.forEach((item, idx) => {
    const headerColArr = value.header[idx]
    const headerItem = headerColArr[0]
    if (headerItem) headerItem.fixed = 1
  })
  const headerRowArr = value.header[value.header.length - 1]
  opts.chartPropertiesHolder.latitudeFields.forEach((item, idx) => {
    const headerItem = headerRowArr[idx]
    if (headerItem) headerItem.fixed = 1
  })

  const rowLength = opts.chartPropertiesHolder.latitudeFields.length
  value.body.forEach((item, idx) => {
    if (idx === 0) {
      for (let i = 0; i < rowLength; i++) {
        const bodyItem = item[i]
        if (bodyItem) bodyItem.fixed = 1
      }
    } else {
      const firstItemLength = value.body[0].length
      const length = rowLength - (firstItemLength - item.length)
      for (let i = 0; i < length; i++) {
        const bodyItem = item[i]
        if (bodyItem) bodyItem.fixed = 1
      }
    }
  })
  console.log('transformData', value)
}

Statistics.prototype.calculateColor = function (value, opts) {

  value = value || this.value
  const conditionalFormatting = opts.showPropertiesHolder.conditionalFormatting

  value.body.forEach((arr, idx) => {
    arr.forEach(v => {

      conditionalFormatting.forEach(item => {

        if (v.linkId === item.linkId) {
          if (v.content !== '-') {

            v.content = parseFloat(v.content)
            if (item.colorType === 'range') {

              item.colorRange.forEach(color => {

                let firstResult = false
                let secondResult = false
                if (v.content === 0 || v.content) {
                  if (color.firstCondition) {
                    if (color.firstCondition.method === 'gte') {
                      firstResult = isNull(color.firstCondition.value) ? true : color.firstCondition.value <= v.content
                    } else if (color.firstCondition.method === 'gt') {
                      firstResult = isNull(color.firstCondition.value) ? true : color.firstCondition.value < v.content
                    }
                  }

                  if (color.secondCondition) {
                    if (color.secondCondition.method === 'gte') {
                      secondResult = isNull(color.secondCondition.value) ? true : v.content <= color.secondCondition.value
                    } else if (color.secondCondition.method === 'gt') {
                      secondResult = isNull(color.secondCondition.value) ? true : v.content < color.secondCondition.value
                    }
                  }
                }

                if (firstResult && secondResult) {
                  v.color = color.color.color
                  v.background = color.color.background
                }
              })
            } else if (item.colorType === 'gradation') {
              const preset = this.presetMap[item.colorGradation]

              const num = value.mmValue[item.linkId]
              num.maxValue = parseFloat(num.maxValue)
              num.minValue = parseFloat(num.minValue)
              let proportion = 0
              if (num.minValue < 0) {
                if (v.content >= 0) {
                  proportion = Math.ceil((v.content + Math.abs(num.minValue)) / (Math.abs(num.maxValue) + Math.abs(num.minValue)) * 100)
                } else {
                  proportion = Math.ceil((Math.abs(num.minValue) - Math.abs(v.content)) / (Math.abs(num.maxValue) + Math.abs(num.minValue)) * 100)
                }
              } else {
                proportion = Math.ceil(v.content / num.maxValue * 100)
              }

              v.color = '#333333'
              const colorList = gradient(preset.startColor, preset.endColor, 100)
              v.background = colorList[proportion - 1]
            } else if (item.colorType === 'bar') {
              const num = value.mmValue[item.linkId]
              num.maxValue = parseFloat(num.maxValue)
              num.minValue = parseFloat(num.minValue)

              let startPercentage = 0
              let endPercentage = 0
              let barColor = ''

              if (num.maxValue > 0 && num.minValue < 0) {
                const total = Math.abs(num.maxValue) + Math.abs(num.minValue)

                // 负数的百分比
                const negativePercentage = Math.abs(num.minValue) / total
                // 正数百分比
                const positivePercentage = Math.abs(num.maxValue) / total

                if (v.content > 0) {
                  const percentage = v.content / num.maxValue * positivePercentage
                  startPercentage = negativePercentage * 100
                  endPercentage = (percentage + negativePercentage) * 100
                  barColor = item.barColor.right
                } else {
                  startPercentage = (negativePercentage - Math.abs(v.content) / Math.abs(num.minValue) * negativePercentage) * 100
                  endPercentage = negativePercentage * 100
                  barColor = item.barColor.left
                }

              } else if (num.maxValue > 0 && num.minValue > 0) {
                startPercentage = 0
                endPercentage = v.content / (Math.abs(num.maxValue) + Math.abs(num.minValue)) * 100
                barColor = item.barColor.right
              } else if (num.maxValue < 0 && num.minValue < 0) {
                startPercentage = (100 - v.content / (Math.abs(num.maxValue) + Math.abs(num.minValue))) * 100
                endPercentage = 100
                barColor = item.barColor.left
              }
              v.color = '#333333'
              v.background = `linear-gradient(to right, transparent ${startPercentage}%, ${barColor} ${startPercentage}%, ${barColor} ${endPercentage}%, transparent ${endPercentage}%) no-repeat`
            }
          }
        }
      })
    })
  })
}

export default Statistics
